export default __webpack_public_path__ + "static/media/section2b-grid2img.8676a617.svg";